/**
 * 入力候補つきテキスト入力(2026-08-27・支払先用)。
 * 何か入力すると、過去の入力から**部分一致**する候補を欄の下に表示する
 * (例:「経費」→「経費〇〇」「〇〇の経費」)。クリックで確定。プルダウン矢印は出ない
 */
import { useMemo, useState } from 'react';

export default function SuggestInput({
  value,
  onChange,
  options,
  placeholder,
}: {
  value: string;
  onChange: (v: string) => void;
  /** 候補の元データ(過去に入力した支払先など) */
  options: string[];
  placeholder?: string;
}) {
  const [focused, setFocused] = useState(false);

  const matches = useMemo(() => {
    const q = value.trim();
    if (!q) return [];
    return options.filter((o) => o.includes(q) && o !== q).slice(0, 8);
  }, [value, options]);

  const open = focused && matches.length > 0;

  return (
    <div style={{ position: 'relative' }}>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        autoComplete="off"
      />
      {open && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 30,
            background: '#fff',
            border: '1px solid var(--line)',
            borderRadius: 6,
            boxShadow: '0 4px 14px rgba(0,0,0,.12)',
            marginTop: 2,
            maxHeight: 220,
            overflowY: 'auto',
          }}
        >
          {matches.map((m) => (
            <div
              key={m}
              // onMouseDown: blurより先に発火させて選択を確定する
              onMouseDown={(e) => {
                e.preventDefault();
                onChange(m);
                setFocused(false);
              }}
              style={{ padding: '7px 12px', fontSize: 13, cursor: 'pointer' }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLDivElement).style.background = 'var(--blue-bg)')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLDivElement).style.background = '')}
            >
              {m}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
